import 'antd/lib/icon/style';
import 'antd/lib/input/style';
import 'antd/lib/select/style';

import '../stateInput.less';
import '../stateSelect.less';